import { io } from 'socket.io-client';
import { toast } from 'react-toastify';

class SocketService {
  constructor() {
    this.socket = null;
    this.isLoggingOut = false;
  }

  connect(userId) {
    if (this.socket) return;
    
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      console.error('❌ No auth token found for ITSales socket connection');
      return;
    }
    
    this.socket = io('https://riskreport.almata.co.jp:3400', {
      path: '/socket.io/',
      transports: ['websocket', 'polling'],
      auth: {
        token: token
      },
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5
    });

    this.socket.on('connect', () => {
      console.log('✅ ITSales socket connected:', this.socket.id);
      this.socket.emit('joinItSalesRoom', userId);
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ ITSales socket connection error:', error);
    });

    this.socket.on('validationResult', (result) => {
      if (result.status === 401) {
        this.handleLogout(result.message);
      }
    });
  }

  startUserValidation(userId, userType) {
    this.connect(userId);
    this.userType = userType;
  }

  handleLogout(reason) {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;
    
    const message = reason === 'inactive' 
      ? 'Your account has been inactivated by the administrator.'
      : 'Your account has been suspended. Please contact administrator.';
    
    // Show toast with longer duration
    toast.error(message, {
      autoClose: 3000,
      closeOnClick: false,
      pauseOnHover: false
    });
    
    // Delay clearing storage and redirect to ensure toast shows
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/login');
    }, 3400);
  }

  stopValidation() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export default new SocketService();